import React from 'react';
import Section from '../components/Section';
import SegmentedControl from '../components/SegmentedControl';
import TextInput from '../components/TextInput';
import {
  QUESTION_TYPE_OPTIONS,
  QUESTION_TITLE_MAX_LENGTH,
  QUESTION_TITLE_MIN_LENGTH,
} from '../constants';
import {questionBonusStyles} from '../styles';
import {BonusQuestionType, QuestionTitleValues} from '../types';
import {countCharacters, truncateCharacters} from '../utils';

interface QuestionSectionProps {
  type: BonusQuestionType;
  title: QuestionTitleValues;
  onChangeType: (questionType: BonusQuestionType) => void;
  onChangeTitle: (title: string) => void;
  readOnly?: boolean;
}

export const QuestionSection = ({
  type,
  title,
  onChangeType,
  onChangeTitle,
  readOnly = false,
}: QuestionSectionProps) => {
  const titleLength = countCharacters(title.fr);
  // On ne signale la longueur insuffisante qu'une fois la saisie commencée.
  const isTitleTooShort =
    titleLength > 0 && titleLength < QUESTION_TITLE_MIN_LENGTH;

  const setTitle = (title: string) => {
    onChangeTitle(truncateCharacters(title, QUESTION_TITLE_MAX_LENGTH));
  };

  return (
    <Section title="02 - Question">
      <div style={questionBonusStyles.sectionColumn}>
        <SegmentedControl
          label="Format de réponse"
          options={QUESTION_TYPE_OPTIONS}
          value={type}
          onChange={onChangeType}
          disabled={readOnly}
        />
        <TextInput
          label="Intitulé de la question"
          required
          value={title.fr}
          onChange={setTitle}
          disabled={readOnly}
          invalid={isTitleTooShort}
          helper={`${titleLength}/${QUESTION_TITLE_MAX_LENGTH} — ${QUESTION_TITLE_MIN_LENGTH} caractères minimum`}
        />
      </div>
    </Section>
  );
};

export default QuestionSection;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/Form/QuestionSection.tsx